import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import SupplierEdit from '@components/shared/suppliers/SupplierEdit';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';
import { useOperatorSupplierService } from '@hooks/operator/suppliers/useOperatorSupplierService';
import { useParams } from 'react-router-dom';

function SupplierNewInner() {
  const supplierService = useOperatorSupplierService();
  return <SupplierEdit service={supplierService} role="operator" />;
}

const OperatorSupplierEdit: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const supplierService = useOperatorSupplierService();
  const { handleRecordLoaded, merchantDataLoading } = useRecordMerchantSync();

  // 編輯模式：wrapper 由 onSupplierLoaded 拿到 record's merchant_id 後同步 context，
  // merchantDataLoading 為 true 時 shared 元件會 gate render，避免閃錯的下拉。
  // Supplier 表單目前沒有 merchant-scoped 下拉（只有靜態 CURRENCY_OPTIONS），
  // 但 wrapper 仍套上 canonical 模式，避免日後加 sales_channel / brand 等欄位時漏改。
  if (id) {
    return (
      <SupplierEdit
        service={supplierService}
        role="operator"
        onSupplierLoaded={handleRecordLoaded}
        merchantDataLoading={merchantDataLoading}
      />
    );
  }

  // 新增模式：MerchantSelect 控制 merchant；record 還不存在，不需要 sync
  return (
    <MerchantSelect>
      <SupplierNewInner />
    </MerchantSelect>
  );
};

export default OperatorSupplierEdit;
